export const ApiConfig =
{
  DashboardGet: 'dashboard/get_count',

  // Auth
  SignInGet: 'sign-in',
  ForgotPassword: 'forgot-password',
  ResetPassword: 'reset-password',
  ChangePassword: 'change-password',
  LogOut: 'logout',
  UpdateProfile: 'update-profile',
  DetailProfile: 'profile',
  UpdateImageProfile: 'remove-profile',
  ResendOtp: 'resend-otp',

  // Cms Pages
  CmsPageGet: 'cms-pages/get',
  CmsDetails: 'cms-pages/detail',
  CmsUpdate: 'cms-pages/update',
  //User Pass  
    UserPassList: "orders/get-passes",
    UserPass:"user-pass/update-refund-info",
    UserPassGet: "user-pass/get",
    UserPassDetail: "user-pass/detail",
    UserPassPdf: "orders/download-pass",
  // User Cookies Management
  UserCookiesGet:"cookies/user-cookies-list",
  UserCookiesDetail:"cookies/user-cookies-detail",

  // Customer Management Page
   CutomerGetList:"users/get",
   CustomerStaus:"users/status",
   CustomerDetails:"users/detail",

  //  Category Mangement
  CategoryGetList :"category/get",
  CategoryAdd:"category/create",
  CategoryStatus:"category/status",
  CategoryDelete:"category/delete",
  categoryDetails:"category/details",
  categoryUpdate:"category/update",

  //  Service Mangement
  ServiceGetList :"services/get",
  ServiceAdd:"services/create",
  ServiceCategoryList:"category/get-list",
  ServiceDetails:"services/details",
  ServiceStatus:"services/status",



  // Salon Mangement 

  SalonGetList :"salon-users/get",
  SalonDetail:"salon-users/detail",
  SalonStatus:"salon-users/status",
  SalonApprovedStatus:"salon-users/approve-status",
  SalonBusinessdelete:"salon-users/remove-business-image",
  SalonUpdate:"salon-users/update",
  SalonDelete:"salon-users/salon-delete",
  SalonSubscriptionActivate: "salon-users/subscription/activate",
  SalonSubscriptionSuspend: "salon-users/subscription/suspend",
  SalonSubscriptionAssignPlan: "salon-users/subscription/assign-plan",



// Staff Mangement

StaffGetList : 'users/get',

// Contact us Mangement
ContactList:"contact-us/get",
ContactDetails:"contact-us/detail",
ContactStatus:"contact-us/reply-contact",


// Faq  Mangement

FaqList :"faqs/get",
FaqCreate:"faqs/create",
FaqStatus:"faqs/status",
Faqdeatils:"faqs/detail",
FaqUpdate:"faqs/update",
FaqDelete:"faqs/delete",

// Offline subscription plans
  SubscriptionPlanList: "subscription-plans/get",
  SubscriptionPlanDetail: "subscription-plans/detail",
  SubscriptionPlanUpdate: "subscription-plans/update",

  SubscriptionPaymentList: "salon-offline-subscriptions/requests/list",
  SubscriptionPaymentApprove: "salon-offline-subscriptions/requests/approve",
  SubscriptionPaymentReject: "salon-offline-subscriptions/requests/reject",
  OfflineBankSettingsGet: "salon-offline-subscriptions/payment-settings/get",
  OfflineBankSettingsUpdate: "salon-offline-subscriptions/payment-settings/update",

// atribute Mangement
AtributeCreate:"attribs/create",
AtributeList:"attribs/get",
AtributeDetails:"attribs/detail",
AtributeUpdate:"attribs/update",
AtributeStatusUpdate:"attribs/status",

// Booking Mangement

BookingList:"booking/get-booking",
BookingDetail:"booking/booking-detail",

// Email template Mangement
EmailtemplateLiist :"email-templates/get",
EmailtemplateDetails:"email-templates/detail",
EmailtemplateEdit :"email-templates/update",

// Rating review Mangement
ReviewRatingList : "review-rating/get",
ReviewRatingDelete: "review-rating/delete",


//Notification Mangement 
 NotificationList: "notifications/get",
 NotificationAdd: "notifications/create"


}

